import styled from "@emotion/styled";
import React from "react";
import SectionCard from "./SectionCard";

interface Props {
  icon: JSX.Element;
  completePercentage: number;
  title: React.ReactNode;
  trailing: React.ReactNode;
  isLocked: boolean;
  onClick: () => void;
}

function SectionCardHeader(props: Props, ref: React.ForwardedRef<HTMLDivElement>) {
  return (
    <SectionCardHeader.Root ref={ref} onClick={props.onClick}>
      <SectionCard.AppListItem
        leading={props.icon}
        trailing={props.trailing}
        soft={true}
        title={<SectionCard.Title>{props.title}</SectionCard.Title>}
      />
    </SectionCardHeader.Root>
  );
}

SectionCardHeader.Root = styled.div`
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #f3f4f5;
`;

export default React.forwardRef(SectionCardHeader);
